import React from 'react'
import { connect } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'
import Header from '../../../components/public/shared/Header'
import Footer from '../../../components/public/shared/Footer'
import { setSubmitChallengeSpace } from '../../../redux/actions/challenge-spaces'
import { isAuthenticated } from '../../../utils/auth'
import _ from 'lodash'
import { scrollToId } from '../../../utils/helpers'

import { wrapper } from '../../../redux/store'
import ScheduleCallSection from 'components/public/shared/ScheduleCallSection'
import ChallengeSpaceLinkToDashboard from 'components/public/challenge-space/ChallengeSpaceLinkToDashboard'
import ChallengeSpaceHeader from 'components/public/challenge-space/ChallengeSpaceHeader'
import ChallengeSubmissionExpired from 'components/public/challenge-space/ChallengeSubmissionExpired'
import ChallengeSpaceSubmitChallengeCard from 'components/public/challenge-space/ChallengeSpaceSubmitChallengeCard'

const basePath = process.env.BASE_PATH

interface SubmitChallengeProps {
	dispatch: any
	challengeSpace: any
	subject: any
	organisation: any
	authenticated: boolean
}

interface SubmitChallengeState {
	showScrollButton: boolean
}

export const getServerSideProps = wrapper.getServerSideProps(
	(store) => async (ctx) => {
		await store.dispatch(setSubmitChallengeSpace(ctx.query.challengeSpaceId))

		let storeData = store.getState()

		const space =
			storeData.public.challengeSpace[`${ctx.query.challengeSpaceId}`]

		// Redirect if space is not active any more or not found
		if (!space || space.attributes.state !== 'active') {
			return {
				notFound: true,
			}
		}

		const subject =
			storeData?.public?.subject[space.relationships?.subject?.data?.id] || null
		const organisation =
			storeData?.public?.organisation[space.relationships.organisation.data.id]

		return {
			props: {
				challengeSpace: space,
				subject: subject,
				organisation: organisation,
				authenticated: isAuthenticated(ctx),
				title: space.attributes.title,
				description: space.attributes.summary,
				url: `${basePath}/challenge-spaces/${space.id}`,
			},
		}
	}
)

// Port in to using useState hooks, if you need state
class SubmitChallenge extends React.Component<
	SubmitChallengeProps,
	SubmitChallengeState
> {
	validatorRef: React.RefObject<any>

	constructor(props) {
		super(props)

		this.validatorRef = React.createRef()

		this.state = {
			// Never show the 'submit as open challenge' on a specific challenge space page
			showScrollButton: false,
		}

		this.onScroll = this.onScroll.bind(this)
	}

	componentDidMount() {
		window.addEventListener('scroll', this.onScroll, false)
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.onScroll, false)
	}

	onScroll() {
		const submitSection = document.getElementById('submitSection')
		const submitSectionFromTop = submitSection.getBoundingClientRect()

		if (submitSectionFromTop.top <= 300) {
			if (this.state.showScrollButton) {
				this.setState({ showScrollButton: false })
			}
		} else {
			if (!this.state.showScrollButton) {
				this.setState({ showScrollButton: true })
			}
		}
	}

	render() {
		const { authenticated, challengeSpace } = this.props

		return (
			<div className="wrapper">
				<Header authenticated={authenticated} />
				<main className="pt-20 pb-56 relative z-20">
					<ChallengeSpaceHeader
						space={challengeSpace}
						subject={this.props.subject}
						organisation={this.props.organisation}
					/>
					<div className="container mx-auto">
						<div className="flex flex-wrap scroll-wrapper justify-center">
							<div className="w-full px-4 py-8 border-b md:border-none">
								<h3 className="text-2xl font-semibold mb-3">Description</h3>

								{this.state.showScrollButton &&
									!challengeSpace.attributes.submissionExpired && (
										<button
											type="button"
											onClick={() => scrollToId('submitSection')}
											className="block z-20 shadow-md fixed lg:hidden bg-yellow-400 hover:bg-yellow-500 text-black"
											style={{
												bottom: '20px',
												left: '50%',
												transform: 'translateX(-50%)',
											}}
										>
											Submit a challenge
										</button>
									)}

								<div className="text-gray-700 whitespace-pre-wrap challengeSpace__description">
									{ReactHtmlParser(challengeSpace.attributes.description)}
								</div>
							</div>

							<div className="w-full self-start px-4">
								<div className="relative" id="submitSection">
									{challengeSpace.attributes.useChallenges ? (
										challengeSpace.attributes.submissionExpired ? (
											<ChallengeSubmissionExpired
												space={challengeSpace}
												subject={this.props.subject}
											/>
										) : this.props.authenticated ? (
											<ChallengeSpaceLinkToDashboard space={challengeSpace} />
										) : (
											<ChallengeSpaceSubmitChallengeCard
												space={challengeSpace}
												organisation={this.props.organisation}
												subject={this.props.subject}
											/>
										)
									) : null}

									{challengeSpace.attributes.useChallenges && (
										<ScheduleCallSection
											title="Want to discuss your challenge before submitting one?"
											externalCallUrl={
												challengeSpace.attributes.externalCallUrl
											}
										/>
									)}
								</div>
							</div>
						</div>
					</div>
				</main>
				<Footer
					spaceTitle={challengeSpace.attributes.title}
					spaceSubject={this.props.subject?.attributes?.title}
					showForm={!challengeSpace.attributes.submissionExpired}
				/>
			</div>
		)
	}
}
export default connect()(SubmitChallenge)
